// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-dialog[data-v-75b30a48] {\n      max-width: 800px;\n      margin: 30px auto;\n}\n.modal-body[data-v-75b30a48] {\n  position:relative;\n  padding:0px;\n}\n.close[data-v-75b30a48] {\n  position:absolute;\n  right:-30px;\n  top:0;\n  z-index:999;\n  font-size:2rem;\n  font-weight: normal;\n  color:#fff;\n  opacity:1;\n}\n", ""]);
// Exports
module.exports = exports;
